import React, { useEffect, useMemo, useState } from 'react';
import {
  Table,
  Button,
  Select,
  Input,
  Card,
  Row,
  Col,
  Modal,
  message,
  Space,
  DatePicker,
  Typography,
  Progress,
  Tooltip,
  Tag,
  Popconfirm
} from 'antd';
import {
  ClearOutlined,
  DownloadOutlined,
  EditFilled,
  EditTwoTone,
  FilterFilled,
  FilterOutlined,
  SearchOutlined,
  SyncOutlined
} from '@ant-design/icons';
import axios from 'axios';
import moment from 'moment';
import { URL_API } from '@configs/';
import './style.css';
import { showError } from '@components/notification';
import { communityList, convertLocaltimeToUTC, formatCurrency, isNullOrEmpty } from '@utils/utils';
import {
  apiGetOriginalData,
  apiSyncData,
  apiSyncTimeData
} from '@services/ManageDevices/DeviceServices';
import { loadFromLocalStorageObjectFromBase64, saveToLocalStorage } from '@databases/localStorage';
import { contantAuthentication } from '@contants/';
import { get, isEmpty, isNumber } from 'lodash';
import { SelectCommunity } from '@page/Common/SelectCommunity';
import {
  apiCalculateStatisticsMonth,
  apiGetConsumptionMonitoring,
  apiGetStatisticsData,
  apiGetStatisticsDataByMonth,
  apiGetStatisticsDataByMonthByCustomerV2,
  apiGetStatisticsDataByMonthDetail,
  apiGetStatisticsDataByMonthV2
} from '@services/ManageCustomers/CustomerServices';
import { apiGetFavoriteFilters } from '@services/ManageCustomers/FavoriteFilterServices';
import { ADMIN_ROLE } from '@utils/constant';
import Chart from '@components/charts/Chart';
import Loading from '@components/Loading';
import { COLORS } from '@components/charts/chart.constant';
import ModalAdjustConsumption from './ModalAdjustConsumption';
import { useRole } from '@contexts/Auth/UseRole';
import FilterAdvanceDrawer from '@components/FilterAdvance';
import ConsumptionCard from './ConsumptionCard';
import { usePermission } from '@contexts/Auth/UsePermission';

const { Option } = Select;

const { RangePicker } = DatePicker;

export default function List() {
  const [data, setData] = useState([]);
  const [flagSearch, setFlagSearch] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedCommunity, setSelectedCommunity] = useState('HP');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [custId, setCustId] = useState(null);
  const [loadingFetch, setLoadingFetch] = useState(false);
  const previousMonthDate = moment().subtract(1, 'month'); // Subtract 1 month
  const [selectedMonth, setSelectedMonth] = useState(moment().format('YYYY-MM'));
  const user = JSON.parse(loadFromLocalStorageObjectFromBase64(contantAuthentication.DATA_AUTH));
  const [dataCharts, setDataCharts] = useState([]);
  const [labelCharts, setLabelCharts] = useState([]);
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [isOpenModalAdjust, setIsOpenModalAdjust] = useState(false);
  const [adjustRow, setAdjustRow] = useState('');
  const [sortedInfo, setSortedInfo] = useState({});
  const [selectedRow, setSelectedRow] = useState({});

  const { consumptionMonitoring } = usePermission();

  const { isWebAdmin, isWebManager, isWebSuperAdmin } = useRole();
  const [isOpen, setIsOpen] = useState(false);
  const [dataFilterAdvance, setDataFilterAdvance] = useState({});
  const [favoriteFilters, setFavoriteFilters] = useState([]);
  const [selectedFavoriteFilter, setSelectedFavoriteFilter] = useState(null);
  const [loadingFavoriteFilters, setLoadingFavoriteFilters] = useState(false);

  const openDrawer = () => {
    setIsOpen(true);
  };

  const onDrawerClose = () => {
    setIsOpen(false);
  };

  // Fetch favorite customer filters
  const fetchFavoriteFilters = async () => {
    try {
      setLoadingFavoriteFilters(true);
      const res = await apiGetFavoriteFilters();
      const customerFilters = (res.data?.data || []).filter((f) => f.filter_type === 'customer');
      setFavoriteFilters(
        customerFilters.map((f) => ({
          label: `${f.filter_name} (${f.item_ids?.length || 0} KH)`,
          value: f.id,
          item_ids: f.item_ids
        }))
      );
    } catch (err) {
      console.error('Error fetching favorite filters:', err);
    } finally {
      setLoadingFavoriteFilters(false);
    }
  };

  useEffect(() => {
    fetchFavoriteFilters();
  }, []);

  const fetchData = async () => {
    try {
      setSelectedRowKey(null);
      setLoadingFetch(true);
      const fromDate = moment(selectedMonth + '-01');
      const res = await apiGetConsumptionMonitoring({
        page: currentPage,
        size: pageSize,
        keyWord: search?.trim() ?? undefined,
        community: selectedCommunity === 'ALL' ? undefined : selectedCommunity,
        period: fromDate.format('YYYY-MM-DD'),
        listCust: selectedFavoriteFilter
          ? favoriteFilters.find((f) => f.value === selectedFavoriteFilter)?.item_ids?.join(',')
          : undefined,
        ...dataFilterAdvance
      });
      setData(
        res.data?.data?.map((item, index) => ({
          ...item,
          stt: (currentPage - 1) * pageSize + 1 + index
        }))
      );
      setTotalItems(res.data?.meta?.total);
    } catch (err) {
      setData([]);
      setSelectedRowKey(null);
      console.log(err);
    } finally {
      setLoadingFetch(false);
    }
  };
  const generateMonthOptions = () => {
    const months = [];
    const current = moment();

    // Current month
    months.push({
      label: `Tháng cước ${current.format('MM/YYYY')}`,
      value: current.format('YYYY-MM')
    });

    // Next month
    const nextMonth = current.clone().add(1, 'month');
    months.push({
      label: `Tháng cước ${nextMonth.format('MM/YYYY')}`,
      value: nextMonth.format('YYYY-MM')
    });

    return months;
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
  };

  const handleChangePageSize = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };
  const onChangeDateRange = (dates, dateStrings) => {
    setDateRange(dates);
  };

  const ActionAdjustColumn = ({ record }) => {
    const handleEdit = async (record) => {
      setAdjustRow(record);
      setIsOpenModalAdjust(true);
    };
    return (
      <>
        {consumptionMonitoring.export && (
          <>
            <Tooltip title="Điều chỉnh tiêu thụ">
              <Button
                type="text"
                shape="circle"
                icon={<EditTwoTone style={{ color: '#0284c7', fontSize: '18px' }} />}
                onClick={() => handleEdit(record)}
              />
            </Tooltip>
          </>
        )}
      </>
    );
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize, flagSearch]);

  const columns = [
    {
      title: 'DBĐD',
      dataIndex: 'customer_id',
      key: 'customer_id',
      fixed: 'left',
      width: 100,
      filterIcon: (filtered) => <FilterFilled style={{ color: filtered ? '#fff' : '#aaa' }} />,
      filters: data.map((item) => ({ text: item.customer_id, value: item.customer_id })),
      onFilter: (value, record) => record.customer_id === value
    },
    {
      title: 'Tên khách hàng',
      dataIndex: 'customer_name',
      key: 'customer_name',
      fixed: 'left',
      width: 200,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Tìm khách hàng"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button type="primary" onClick={() => confirm()} icon={<SearchOutlined />} size="small">
              Tìm kiếm
            </Button>
            <Button onClick={() => clearFilters()} size="small">
              Xoá lọc
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => <FilterFilled style={{ color: filtered ? '#fff' : '#aaa' }} />,
      onFilter: (value, record) => record.customer_name.toLowerCase().includes(value.toLowerCase())
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'address',
      width: 200
    },
    {
      title: 'CN',
      dataIndex: 'branch',
      width: 100
    },
    {
      title: 'TQL',
      dataIndex: 'manage_group',
      width: 100
    },
    {
      title: 'DHK',
      dataIndex: 'parent_device',
      width: 100
    },
    {
      title: 'Tuyến',
      dataIndex: 'route',
      key: 'route',
      width: 100,
      filters: [...new Set(data.map((item) => item.route))].map((route) => ({
        text: route,
        value: route
      })),
      filterIcon: (filtered) => <FilterFilled style={{ color: filtered ? '#fff' : '#aaa' }} />,
      onFilter: (value, record) => record.route === value
    },

    {
      title: 'Cỡ ĐH',
      dataIndex: 'size',
      width: 90
    },
    {
      title: 'Kỳ hoá đơn',
      dataIndex: 'period',
      key: 'period',
      render: (_, record) => (
        <>{record?.period ? moment(record?.period).format('MM/YYYY') : 'N/A'}</>
      ),
      width: 120
    },
    {
      title: 'Từ ngày',
      dataIndex: 'first_day',
      key: 'first_day',
      width: 150
    },
    {
      title: 'Đến ngày',
      dataIndex: 'last_day',
      key: 'last_day',
      width: 150
    },
    {
      title: 'Chỉ số cũ (m3)',
      dataIndex: 'start_reading',
      key: 'start_reading',
      render: (_, record) => (
        <>{record?.start_reading ? formatCurrency(record?.start_reading, 3) : 'N/A'}</>
      ),
      width: 150
    },
    {
      title: 'Chỉ số mới (m3)',
      dataIndex: 'end_reading',
      key: 'end_reading',
      render: (_, record) => (
        <>{record?.end_reading ? formatCurrency(record?.end_reading, 3) : 'N/A'}</>
      ),
      width: 150
    },
    {
      title: (
        <div>
          <div>Tiêu thụ (m3)</div>
        </div>
      ),
      render: (_, record) => (
        <>
          {!isNullOrEmpty(record?.final_consumption)
            ? formatCurrency(record?.final_consumption, 3)
            : 'N/A'}
        </>
      ),
      width: 150
    },

    {
      title: 'Ghi chú',
      dataIndex: 'note',
      key: 'note',
      render: (_, record) => (
        <>
          {record?.adjusted_consumption_value !== null ? (
            <>
              <div style={{ color: '#1A1A1A', fontSize: '15px' }}>{`${record?.remarks}`}</div>
              <div
                style={{
                  color: '#5D5D5D',
                  fontSize: '13px',
                  fontStyle: 'italic'
                }}>{`Điều chỉnh bởi ${record?.adjusted_by} lúc ${record?.adjusted_at}`}</div>
            </>
          ) : (
            <span style={{ color: '#e11d48', fontSize: '14px' }}>
              {record?.first_day == 'Chưa gán' || record?.last_day == 'Chưa gán'
                ? 'Chưa gán lịch ghi số / Chưa gán thiết bị'
                : !isNullOrEmpty(record?.consumption)
                ? ''
                : 'Không đủ dữ liệu tính toán tiêu thụ'}
            </span>
          )}
        </>
      ),
      width: 250
    }
  ];

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleCustIdChange = (e) => {
    setCustId(e.target.value);
  };

  const [loading, setLoading] = useState(false);
  const handleExportExcelButtonClick = async () => {
    try {
      let user = loadFromLocalStorageObjectFromBase64(contantAuthentication.DATA_AUTH);
      if (!isEmpty(user)) {
        user = JSON.parse(user);
      }
      setLoading(true);
      const fromDate = moment(selectedMonth + '-01');
      const response = await axios.get(`${URL_API}/api/customer/v2/consumption-monitoring/export`, {
        params: {
          keyWord: search?.trim() ?? undefined,
          community: selectedCommunity === 'ALL' ? undefined : selectedCommunity,
          period: fromDate.format('YYYY-MM-DD'),
          listCust: selectedFavoriteFilter
            ? favoriteFilters.find((f) => f.value === selectedFavoriteFilter)?.item_ids?.join(',')
            : undefined,
          ...dataFilterAdvance
        },
        headers: {
          Authorization: `Bearer ${user?.accessToken}`
        },
        responseType: 'blob'
      });
      const type = response.headers['content-type'];
      const blob = new Blob([response.data], { type: type });
      const link1 = document.createElement('a');
      link1.href = window.URL.createObjectURL(blob);
      link1.setAttribute('download', `Thong_ke_tieu_thu_thang_${selectedMonth}.xlsx`);
      document.body.appendChild(link1);
      link1.click();
    } catch (error) {
      console.log(error);
      showError(
        'Kỳ tính cước chưa được gán cấu hình ghi số' || 'Vui lòng liên hệ admin để được hỗ trợ'
      );
    } finally {
      setLoading(false);
    }
  };
  const [loadingSync, setLoadingSync] = useState(false);
  const [loadingFetchChart, setLoadingFetchChart] = useState(false);
  const [dataStatisticsDetail, setDataStatisticsDetail] = useState(null);
  const fetchDataChart = async (customerId) => {
    try {
      const fromDate = moment(selectedMonth + '-01');
      setLoadingFetchChart(true);
      const res = await apiGetStatisticsDataByMonthByCustomerV2({
        customer_id: customerId,
        period: fromDate.format('YYYY-MM-DD') // convertLocaltimeToUTC(fromDate, '00:00:00.000'),
      });
      if (!res?.data?.data?.length) {
        showError('Khách hàng bạn chọn không có dữ liệu tiêu thụ theo ngày');
        setSelectedRowKey(null);
        return;
      }
      setDataStatisticsDetail(res?.data?.data);
      const convertData = [
        {
          name: 'Tiêu thụ ngày',
          data: res?.data?.data?.map((item) =>
            isNumber(item?.water_consumption_of_the_day) ? item?.water_consumption_of_the_day : 0
          ),
          type: 'bar'
        }
      ];
      setDataCharts(convertData);
      console.log(convertData);

      const convertLabel = res?.data?.data?.map(
        (item) => item?.denseData_startCollectionTime ?? 'chưa có dữ liệu'
      );
      setLabelCharts(convertLabel);
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingFetchChart(false);
    }
  };

  const handleRowClick = async (row) => {
    setSelectedRowKey(row?.stt);
    setSelectedRow(row);
    fetchDataChart(row?.customer_id);
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  };

  const clearFilter = () => {
    setSearch('');
    setCurrentPage(1);
    setSelectedMonth(previousMonthDate.format('YYYY-MM'));
    setDataFilterAdvance({});
    setFlagSearch(!flagSearch);
  };

  return (
    <div>
      <ModalAdjustConsumption
        open={isOpenModalAdjust}
        onClose={() => setIsOpenModalAdjust(false)}
        record={adjustRow}
        fetchData={fetchData}
      />
      <Row justify="space-between" align="middle">
        <Col>
          <Typography.Title level={4}>Theo dõi tiêu thụ</Typography.Title>
        </Col>
        {(isWebAdmin || isWebManager || isWebSuperAdmin) && (
          <Col>
            <Button
              icon={<DownloadOutlined />}
              onClick={handleExportExcelButtonClick}
              loading={loading}
              style={{
                backgroundColor: 'var(--action-export-bg)',
                borderColor: 'var(--action-export-border)',
                color: 'var(--action-export-text)',
                height: '36px',
                fontWeight: '500'
              }}>
              Xuất báo cáo
            </Button>
          </Col>
        )}
      </Row>
      <Card
        bodyStyle={{
          padding: '16px'
        }}>
        <Row gutter={[8, 8]} style={{ marginBottom: '16px' }}>
          <Col xs={24} sm={2} md={2}>
            <Button
              icon={<FilterOutlined />}
              onClick={openDrawer}
              style={{
                backgroundColor: 'var(--surface-3)',
                color: 'var(--text)',
                borderColor: 'var(--border)',
                width: '100%',
                maxWidth: 44
              }}
            />
          </Col>
          <Col xs={24} sm={12} md={4}>
            <Select
              style={{ width: '100%', height: '36px' }}
              placeholder="Chọn tháng cước"
              value={selectedMonth}
              onChange={handleMonthChange}>
              {generateMonthOptions().map((month) => (
                <Option key={month.value} value={month.value}>
                  {month.label}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={5}>
            <Select
              placeholder="Chọn Bộ lọc theo dõi..."
              value={selectedFavoriteFilter}
              onChange={(value) => {
                setSelectedFavoriteFilter(value);
                setCurrentPage(1);
              }}
              loading={loadingFavoriteFilters}
              allowClear
              options={favoriteFilters}
              style={{ width: '100%', height: '36px' }}
            />
          </Col>{' '}
          <Col xs={24} sm={12} md={5}>
            <Input
              style={{ height: '36px', width: '100%' }}
              size="small"
              placeholder="Tìm kiếm theo số mã KH, imei..."
              value={search}
              onChange={handleSearchChange}
              onPressEnter={() => {
                setCurrentPage(1);
                setFlagSearch(!flagSearch);
              }}
            />
          </Col>
          {/* <Col md={5} xs={6}>
            <SelectCommunity value={selectedCommunity} onChange={setSelectedCommunity} />
          </Col> */}
          <Col
            xs={24}
            sm={12}
            md={8}
            style={{ display: 'flex', justifyContent: 'flex-end', minWidth: 0 }}>
            <Space wrap style={{ maxWidth: '100%', justifyContent: 'flex-end' }}>
              <Button
                style={{
                  borderColor: 'var(--border)',
                  backgroundColor: 'var(--surface-3)',
                  color: 'var(--text)',
                  height: '36px'
                }}
                icon={<ClearOutlined />}
                onClick={clearFilter}>
                Xoá bộ lọc
              </Button>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => {
                  setCurrentPage(1);
                  setFlagSearch(!flagSearch);
                }}
                style={{
                  height: '36px',
                  backgroundColor: '#0284c7',
                  borderColor: '#0284c7'
                  // fontSize: '18px'
                }}>
                Tìm kiếm
              </Button>
            </Space>
          </Col>
        </Row>
        {/* <ConsumptionCard
          selectedMonth={selectedMonth}
          dataFilterAdvance={dataFilterAdvance}
          flagSearch={flagSearch}
          keyWord={search}
        /> */}
      </Card>
      <Table
        bordered
        // size="middle"
        loading={loadingFetch}
        dataSource={data || []}
        columns={columns}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalItems,
          showSizeChanger: true,
          onChange: handleChangePage,
          onShowSizeChange: handleChangePageSize,
          showTotal: (total, range) => `${range[0]}-${range[1]} của ${total} bản ghi`
        }}
        rowClassName={(record) => (selectedRowKey === record.stt ? 'ant-table-row-selected' : '')}
        onRow={(record) => ({
          onClick: () => handleRowClick(record), // Click handler for rows
          style: { cursor: 'pointer' }
        })}
        style={{
          borderRadius: 8,
          thead: { backgroundColor: '#e2e8f0', color: '#64748b' },
          fontSize: '30px'
        }}
        scroll={{ x: 'max-content', y: 400 }}
      />

      {selectedRowKey && (
        <>
          <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
            <Col md={10} xs={12}>
              <Card
                title={'Chi tiết sử dụng'}
                loading={loadingFetch}
                headStyle={{ fontSize: '15px' }}
                bodyStyle={{ padding: '16px' }}>
                <Typography style={{ fontSize: '15px', fontWeight: '400', color: '#0369a1' }}>
                  Mã khách hàng: <strong>{selectedRow?.customer_id}</strong>
                </Typography>
                <Typography style={{ fontSize: '15px', fontWeight: '400', color: '#0369a1' }}>
                  Tên khách hàng: <strong>{selectedRow?.customer_name}</strong>
                </Typography>
                <table
                  className="table col-12"
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    marginBottom: '16px',
                    fontSize: '15px',
                    fontWeight: '400',
                    color: '#0369a1',
                    marginTop: '16px'
                  }}>
                  <tbody>
                    <tr>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Kỳ hóa đơn: <strong>{moment(selectedRow?.period).format('MM/YYYY')}</strong>
                      </td>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Từ ngày: <strong>{selectedRow?.first_day ?? '-'}</strong>
                      </td>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Chỉ số cũ:{' '}
                        <strong>
                          {' '}
                          {!isNullOrEmpty(selectedRow?.start_reading)
                            ? formatCurrency(selectedRow?.start_reading, 3)
                            : '-'}
                        </strong>
                      </td>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Tuyến: <strong>{selectedRow?.route ?? '-'}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td
                        className="cn_color"
                        style={{ border: '1px solid #ddd', padding: '8px' }}></td>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Đến ngày: <strong>{selectedRow?.last_day ?? '-'}</strong>
                      </td>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Chỉ số mới:{' '}
                        <strong>
                          {!isNullOrEmpty(selectedRow?.end_reading)
                            ? formatCurrency(selectedRow?.end_reading, 3)
                            : '-'}
                        </strong>
                      </td>
                      <td className="cn_color" style={{ border: '1px solid #ddd', padding: '8px' }}>
                        Số m³ tiêu thụ:{' '}
                        <strong>
                          {' '}
                          {!isNullOrEmpty(selectedRow?.final_consumption)
                            ? formatCurrency(selectedRow?.final_consumption, 3)
                            : '-'}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Card>
            </Col>
            <Col md={14} xs={12}>
              <Card
                title={' Biểu đồ thống kê tiêu thụ theo ngày'}
                loading={loadingFetch}
                headStyle={{ fontSize: '15px' }}
                bodyStyle={{ padding: '16px' }}>
                {' '}
                {loadingFetchChart ? (
                  <Loading />
                ) : (
                  <>
                    {/* <Typography.Title style={{ fontSize: '16px', marginTop: '0px' }}>
                      {`${dataStatisticsDetail?.[0]?.customer_id} - ${dataStatisticsDetail?.[0]?.customer_name}`}{' '}
                      ({selectedMonth})
                    </Typography.Title> */}
                    <Chart
                      options={{
                        colors: COLORS,
                        chart: {
                          zoom: {
                            enabled: false
                          },
                          toolbar: {
                            show: true
                          }
                        },
                        plotOptions: {
                          bar: {
                            horizontal: false,
                            columnWidth: '18px',
                            borderRadius: 8
                          }
                        },
                        fill: {
                          opacity: 1
                        },
                        dataLabels: {
                          enabled: false
                        },
                        stroke: {
                          show: true,
                          width: 2,
                          colors: ['transparent']
                        },
                        labels: labelCharts,
                        yaxis: {
                          show: true
                        },
                        grid: {
                          show: true
                        },
                        tooltip: {
                          y: {
                            formatter: (val) => `${formatCurrency(val)} lít`
                          }
                        },
                        legend: {
                          horizontalAlign: 'left'
                        }
                      }}
                      type="bar"
                      series={dataCharts}
                      height={400}
                    />
                  </>
                )}
              </Card>
            </Col>
          </Row>
        </>
      )}
      <FilterAdvanceDrawer
        isOpen={isOpen}
        onDrawerClose={onDrawerClose}
        dataFilterAdvance={dataFilterAdvance}
        setDataFilterAdvance={setDataFilterAdvance}
        flagSearch={flagSearch}
        setFlagSearch={setFlagSearch}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
}
